module.exports = __webpack_public_path__ + "assets/train.8bcf2d38.svg";